/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/packs/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 121);
/******/ })
/************************************************************************/
/******/ ({

/***/ 121:
/***/ (function(module, exports) {

var convert_string_boolean_to_boolean = function convert_string_boolean_to_boolean(value) {
  return value == "true" ? true : false;
};

var bxSliderLoading = function bxSliderLoading(bxslider) {
  var hash_bxslider = {
    minSlides: bxslider.getAttribute("data-minslides"),
    maxSlides: bxslider.getAttribute("data-maxslides"),
    mode: bxslider.getAttribute("data-mode"),
    adaptiveHeight: convert_string_boolean_to_boolean(bxslider.getAttribute("data-adaptiveheight")),
    pager: convert_string_boolean_to_boolean(bxslider.getAttribute("data-pager")),
    captions: convert_string_boolean_to_boolean(bxslider.getAttribute("data-captions")),
    auto: convert_string_boolean_to_boolean(bxslider.getAttribute("data-auto")),
    ticker: convert_string_boolean_to_boolean(bxslider.getAttribute("data-ticker")),
    speed: bxslider.getAttribute("data-speed"),
    pause: bxslider.getAttribute("data-pause")
  };

  if (bxslider.getAttribute("data-slidewidth")) {
    hash_bxslider["slideWidth"] = bxslider.getAttribute("data-slidewidth");
  };
  if (bxslider.getAttribute("data-slidemargin")) {
    hash_bxslider["slideMargin"] = bxslider.getAttribute("data-slidemargin");
  };
  $('.bxslider').bxSlider(hash_bxslider);
};

document.addEventListener("DOMContentLoaded", function () {
  var bxslider = document.querySelector(".boxslider");
  if (bxslider) {
    bxSliderLoading(bxslider);
  };
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// bxslider-0933f94fabdb244005bb.js